import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/shared/cn";

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  actions?: ReactNode;
  flush?: boolean;
}

export function Card({ title, actions, flush = false, className, children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        "min-w-0 rounded-(--card-r) border border-(--line) bg-(--paper)",
        flush ? null : "p-(--card-p)",
        className,
      )}
      {...rest}
    >
      {(title != null || actions != null) && (
        <div className="mb-[12px] flex flex-wrap items-center justify-between gap-[8px]">
          {title != null && (
            <h3 className="m-0 text-lg font-medium tracking-[-0.02em] text-(--ink)">{title}</h3>
          )}
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}
